/**
 * Instantiate a singleton TasksApi instance for the app.
 */
import {
  Configuration,
  ConfigurationParameters,
  EnvironmentsApi,
  HoldoutsApi,
  FlagsApi,
  GroupsApi,
  ReportsApi,
  RulesetsApi,
  RulesApi,
  RulesPrivateApi,
  ScheduledChangesApi,
  ScheduledChangeApi,
  VariationsApi,
  VariableDefinitionsApi,
  PermissionsApi,
  ChangeApprovalsApi,
} from 'types/backend';

// Temporarily auth via the API_GW_TOKEN cookie.
// @ts-ignore
const API_GW_TOKEN: string = ('; ' + (document.cookie || ''))
  .split('; API_GW_TOKEN=')
  .pop()
  .split(';')
  .shift();

declare var __BASE_BACKEND_URL__: string;
declare var __SCHEDULING_BACKEND_URL__: string;
let apiConfigParams: ConfigurationParameters = {
  credentials: 'include',
};
if (API_GW_TOKEN) {
  apiConfigParams.headers = { Authorization: 'Bearer ' + API_GW_TOKEN };
}
if (__BASE_BACKEND_URL__) {
  apiConfigParams.basePath = __BASE_BACKEND_URL__;
}

let scheduleApiConfigParams: ConfigurationParameters = {
  basePath: 'http://localhost:8010',
  credentials: 'include',
};
if (__SCHEDULING_BACKEND_URL__) {
  scheduleApiConfigParams.basePath = __SCHEDULING_BACKEND_URL__;

  // Do not include cookies for requests to localhost (for local development)
  if (scheduleApiConfigParams.basePath.startsWith('http://localhost')) {
    scheduleApiConfigParams.credentials = 'same-origin';
  }
}

const flagsApiConfig: Configuration = new Configuration(apiConfigParams);
export const flags = new FlagsApi(flagsApiConfig);

const groupsApiConfig: Configuration = new Configuration(apiConfigParams);
export const groups = new GroupsApi(groupsApiConfig);

const holdoutsApiConfig: Configuration = new Configuration(apiConfigParams);
export const holdouts = new HoldoutsApi(holdoutsApiConfig);

const rulesetApiConfig: Configuration = new Configuration(apiConfigParams);
export const rulesets = new RulesetsApi(rulesetApiConfig);

const variationsApiConfig: Configuration = new Configuration(apiConfigParams);
export const variations = new VariationsApi(variationsApiConfig);

const reportsApiConfig: Configuration = new Configuration(apiConfigParams);
export const reports = new ReportsApi(reportsApiConfig);

const environmentsApiConfig: Configuration = new Configuration(apiConfigParams);
export const environments = new EnvironmentsApi(environmentsApiConfig);

const permissionsApiConfig: Configuration = new Configuration(apiConfigParams);
export const permissions = new PermissionsApi(permissionsApiConfig);

const rulesPrivateApiConfig: Configuration = new Configuration(apiConfigParams);
export const ruleSearch = new RulesPrivateApi(rulesPrivateApiConfig);

const rulesApiConfig: Configuration = new Configuration(apiConfigParams);
export const rules = new RulesApi(rulesApiConfig);

const variablesApiConfig: Configuration = new Configuration(apiConfigParams);
export const variables = new VariableDefinitionsApi(variablesApiConfig);

const schedulesApiConfig: Configuration = new Configuration(
  scheduleApiConfigParams
);
export const schedules = new ScheduledChangesApi(schedulesApiConfig);

const scheduleApiConfig: Configuration = new Configuration(
  scheduleApiConfigParams
);
export const schedule = new ScheduledChangeApi(scheduleApiConfig);

export const changeApprovals = new ChangeApprovalsApi(scheduleApiConfig);
